/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as CommunicationDefs from './defs.defs.js'

const $nsid = 'tools.ozone.communication.listTemplates'

export { $nsid }

/** Get list of all communication templates. */
const main = l.query(
  $nsid,
  l.params(),
  l.jsonPayload({
    communicationTemplates: l.array(
      l.ref<CommunicationDefs.TemplateView>(
        (() => CommunicationDefs.templateView) as any,
      ),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
